import Ajax from './ajax';

function info(msg, logsChannel = false, channel = null) {
  let resp = Ajax.post({
    withErrorHandling: false,
    url: '/log',
    data: {
      msg,
      'logs-channel': logsChannel,
      channel: channel,
    },
  }).catch(() => {});

  return resp;
}

function track(msg) {
  let resp = Ajax.post({
    withErrorHandling: false,
    url: '/log',
    data: {
      msg,
      'logs-channel': false,
      channel: '#log-track',
    },
  }).catch(() => {});

  return resp;
}

export default {
  info,
  track,
};
